import { ChevronDown } from "lucide-react";
import Link from "next/link";
import styled from "styled-components";

interface SidebarProps {
  $isOpen: boolean;
}

interface ActiveProps {
  $isActive: boolean;
}

export const Sidebar = styled.div<SidebarProps>`
  width: ${({ $isOpen }) => ($isOpen ? "16rem" : "68px")};
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  transition: width 0.3s ease-in-out;
  z-index: 999;
  background-color: var(--backgroundColorCard);

  @media (max-width: 991px) {
    display: none;
  }
`;

export const HeaderSidebar = styled.div`
  width: 100%;
  height: 4.5em;
  border-bottom: 1px solid var(--borderColorLight);
  background: var(--backgroundColorCard);
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--border);
`;

export const LogoLink = styled.a<SidebarProps>`
  width: ${({ $isOpen }) => ($isOpen ? "100px" : "60px")};
  transition: width 0.3s ease-in-out;
`;

export const ButtonNavigation = styled.button<SidebarProps>`
  position: absolute;
  right: -7px;
  border-radius: 100px;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: var(--backgroundColorCard);

  @media (min-width: 992px) {
    background: transparent;
  }

  svg {
    transform: ${({ $isOpen }) => ($isOpen ? "rotate(180deg)" : "rotate(0)")};
    transition: transform 0.3s easy-out;

    path {
      transition: 0.3s;
      stroke: var(--primarySystem100);
      fill: transparent;
    }
  }

  &:hover {
    background: var(--primarySystem100);

    svg {
      path {
        stroke: #fff;
      }
    }
  }
`;

export const BoxNavigation = styled.nav`
  height: calc(100vh - 4.5em);
  background: var(--backgroundColorCard);

  @media (min-width: 992px) {
    background: transparent;
  }
`;

export const ListNavigation = styled.ul`
  padding: 0 0.75rem;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  overflow-y: auto;
  height: 100%;

  &::-webkit-scrollbar-track {
    background: var(--transparent);
  }

  &::-webkit-scrollbar {
    width: 3px;
    background: var(--transparent);
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: var(--border);
  }
`;

export const ItemList = styled.li`
  width: 100%;
`;

export const BoxItemAccordion = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex-direction: column;
  position: relative;
`;

export const LinkLost = styled(Link)<ActiveProps>`
  font-family: "Roboto Light";
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 12px;
  border-radius: 0.5rem;
  cursor: pointer;
  color: var(--textColor);

  ${({ $isActive }) =>
    $isActive &&
    `
background: var(--primarySystem100);
color: #fff;

&:hover{
    color: var(--textColor);
}
`}

  &:hover {
    background: var(--lightGray);
  }
`;

export const ButtonAccordion = styled.button<ActiveProps>`
  font-family: "Roboto Light";
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 12px;
  border-radius: 0.5rem;
  cursor: pointer;
  color: var(--textColor);
  overflow: hidden;

  ${({ $isActive }) =>
    $isActive &&
    `
background: var(--primarySystem100);
color: #fff;

&:hover{
    color: var(--textColor);
}
`}

  &:hover {
    background: var(--primarySystem100);
    color: #fff;
  }
`;

export const InfoNavigation = styled.div`
  display: flex;
  align-items: center;
`;

export const IconNavigation = styled.span``;

export const TextNavigation = styled.span`
  white-space: nowrap;
  margin-left: 0.75rem;
`;

export const IconChevronDown = styled(ChevronDown)`
  font-size: 16px;
  height: 20px;
`;

export const SubListNavigation = styled.ul<SidebarProps>`
  padding-top: 10px;
  width: 100%;
  padding-left: 15px;
  display: flex;
  flex-direction: column;
  gap: 3px;

  ${({ $isOpen }) =>
    $isOpen
      ? `
position: relative;
`
      : `
position: fixed;
width: fit-content;
left: 68px;
padding: 5px;
border-bottom: 1px solid var(--borderColorLight);
background: var(--backgroundColor);
border-radius: 0.5rem;
box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.04);
max-height: calc(100vh - 6.5em);
overflow-y: auto;
z-index: 1100;
`}
`;

export const SubItemNavigation = styled.li`
  display: flex;
`;

export const LinkNavigation = styled(Link)<ActiveProps>`
  font-family: "Roboto Light";
  font-weight: 500;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 5px 10px;
  border-radius: 0.5rem;
  font-size: 1rem;
  gap: 8px;
  overflow: hidden;
  ${({ $isActive }) =>
    $isActive &&
    `
background: #D0D0D0;
`}

  &:hover {
    background: #d0d0d0;
  }
`;

export const IconSubNavigation = styled.span`
  color: var(--textColor);
`;

export const SubTextNavigation = styled.span`
  color: var(--textColor);
`;
